<template>
  <div
    class="shop-category-list-item"
    v-for="item of FEATURED_LIST"
    :key="item.name"
    @click="router.push(item.path)"
  >
    <img
      class="icon"
      src="https://cdn-image.bestdealer.com/app-bestdealer/1688/category/featured-shoes.png"
    >
    {{ item.label[language.current] }}
  </div>
</template>

<script setup>
import { FEATURED_LIST } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'

const router = useRouter()
const language = useLanguageStore()
</script>

<style lang="less" scoped>
</style>
